export default __webpack_public_path__ + "resources/icons/d320-e8f3.png";